/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   const variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   const cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

// 374px未満のデバイスのレスポンシブ対応
!(function () {
  const viewport = document.querySelector('meta[name="viewport"]');

  function switchViewport() {
    const value = window.outerWidth > 374 ? "width=device-width,initial-scale=1" : "width=374";

    if (viewport.getAttribute("content") !== value) {
      viewport.setAttribute("content", value);
    }
  }

  addEventListener("resize", switchViewport, false);
  switchViewport();
})();

/**
 * カテゴリー一覧の開閉：もっと詳しく / 閉じる
 * - 初期：4個目まで完全表示、5個目title途中で切れる
 * - クリックで全表示、ボタン文言・アイコン切り替え
 * - scrollHeight を使って正確な高さまでアニメーション（シームレスな開閉）
 * - 閉じたときの max-height は CSS と統一（PC: 535px / スマホ740px以下: 680px）
 */
(function () {
  const btn = document.getElementById("searchCategoryBtn");
  const wrapper = document.getElementById("searchCategoryContent");
  const container = btn?.closest(".c-search-category__container");
  if (!btn || !wrapper) return;

  const LABEL_OPEN = "閉じる";
  const LABEL_CLOSE = "もっと詳しく";
  const COLLAPSED_HEIGHT_PC = 535;
  const COLLAPSED_HEIGHT_MOBILE = 680;
  const MOBILE_BREAKPOINT = "(max-width: 740px)";

  function getCollapsedHeight() {
    return window.matchMedia(MOBILE_BREAKPOINT).matches ? COLLAPSED_HEIGHT_MOBILE : COLLAPSED_HEIGHT_PC;
  }

  btn.addEventListener("click", function () {
    const isExpanded = !wrapper.classList.contains("is-expanded");
    wrapper.classList.toggle("is-expanded", isExpanded);
    btn.classList.toggle("is-expanded", isExpanded);
    if (container) container.classList.toggle("is-expanded", isExpanded);
    btn.textContent = isExpanded ? LABEL_OPEN : LABEL_CLOSE;
    btn.setAttribute("aria-expanded", String(isExpanded));

    if (isExpanded) {
      wrapper.style.maxHeight = wrapper.scrollHeight + "px";
    } else {
      const fromHeight = wrapper.scrollHeight;
      wrapper.style.maxHeight = fromHeight + "px";
      wrapper.offsetHeight; /* reflow で transition の開始値を確定 */
      wrapper.style.maxHeight = getCollapsedHeight() + "px";
    }
  });

  /* 閉じた状態でリサイズ時、ブレイクポイントに合わせて max-height を更新 */
  window.addEventListener("resize", function () {
    if (!wrapper.classList.contains("is-expanded") && wrapper.style.maxHeight) {
      wrapper.style.maxHeight = getCollapsedHeight() + "px";
    }
  });
})();

/**
 * "Type（タイプ）" → "Type <span class="c-mobile-nav__text--jp">タイプ</span>" 整形
 * 対象: level2リンク + level3パネル + MegaMenuCategory__TabLink + Item__ParentLink + 絞り込みフィルター
 */
(function () {
  function formatParenthesesToSpan(el) {
    const isFacetToggle = el.classList.contains('collapsible-toggle') && el.closest('.product-facet__filters');
    if (isFacetToggle && el.querySelector('.c-product-facet__toggle-text')) return;
    if (el.closest('.product-facet__filters') && el.querySelector('.c-product-facet__label-jp')) return;

    const text = el.textContent.trim();
    const match = text.match(/^(.+?)（(.+?)）(.*)$/);
    let newContent;

    if (match) {
      const enPart = match[1].trim();
      const jpPart = match[2].trim();
      const suffix = (match[3] || '').trim();
      const jpClass = el.closest('.product-facet__filters') ? 'c-product-facet__label-jp' : (el.classList.contains('Item__ParentLink') ? 'c-item-parent-link_jp' : 'c-mobile-nav__text--jp');
      newContent = enPart + ' <span class="' + jpClass + '">' + jpPart + '</span>' + (suffix ? ' ' + suffix : '');
    } else if (isFacetToggle) {
      newContent = text;
    } else {
      return;
    }

    /* collapsible-toggle のときのみプラス/マイナスアイコンを保持。それ以外（メガメニュー等）は子を preserve しない */
    let preserved = [];
    if (isFacetToggle) {
      preserved = Array.from(el.children).filter(function (c) {
        return c.classList && c.classList.contains('c-product-facet__toggle-icon');
      });
    }

    if (isFacetToggle) {
      newContent = '<div class="c-product-facet__toggle-text">' + newContent + '</div>';
    }

    el.innerHTML = newContent;
    preserved.forEach(function (child) {
      el.appendChild(child);
    });
  }

  function formatMobileNavLevel2Links() {
    const links = document.querySelectorAll('.mobile-nav__item[data-level="2"] > .mobile-nav__link, .c-mobile-menu_level3-title, .MegaMenuCategory__TabLink, .Item__ParentLink, .product-facet__filters .collapsible-toggle, .product-facet__filters .checkbox-container label, .product-facet__filters .block-swatch label');
    links.forEach(function (link) {
      formatParenthesesToSpan(link);
    });
  }

  let formatDebounceTimer = null;
  function scheduleFacetFormat() {
    if (formatDebounceTimer) clearTimeout(formatDebounceTimer);
    formatDebounceTimer = setTimeout(function () {
      formatDebounceTimer = null;
      formatMobileNavLevel2Links();
    }, 150);
  }

  function setupFacetFiltersObserver() {
    document.querySelectorAll('product-facet #facet-filters').forEach(function (facetFilters) {
      if (facetFilters.dataset.facetFormatObserved) return;
      facetFilters.dataset.facetFormatObserved = '1';
      const observer = new MutationObserver(function () {
        scheduleFacetFormat();
      });
      observer.observe(facetFilters, { childList: true, subtree: true });
    });
  }

  function initFormatAndObserve() {
    formatMobileNavLevel2Links();
    setupFacetFiltersObserver();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFormatAndObserve);
  } else {
    initFormatAndObserve();
  }

  document.addEventListener('mobile-nav:open', function () {
    setTimeout(formatMobileNavLevel2Links, 0);
  });

  document.addEventListener('facet:criteria-changed', function () {
    scheduleFacetFormat();
  });

  document.addEventListener('shopify:section:load', function () {
    initFormatAndObserve();
  });
})();

/**
 * モバイルメニュー level3: アコーディオンではなく「次画面（パネル）」で表示
 * - 対象: level2で子（level3）を持つ項目のみ
 * - level2クリックで該当パネルをスライド表示（100vh相当）
 * - 戻るで閉じて元の画面へ（フォーカスも復帰）
 */
(function () {
  let initialized = false;
  const lastTriggerByPanels = typeof WeakMap !== 'undefined' ? new WeakMap() : null;
  let resetTimer = null;

  function getDrawer() {
    return document.getElementById('mobile-menu-drawer');
  }

  function getPanels(drawer) {
    return drawer ? drawer.querySelector('.c-mobile-menu_level3-panels') : null;
  }

  function closeAllLevel3(drawer) {
    const panels = getPanels(drawer);
    if (!drawer || !panels) return;

    drawer.classList.remove('is-level3-open');
    panels.setAttribute('aria-hidden', 'true');

    const activePanels = panels.querySelectorAll('.c-mobile-menu_level3-panel.is-active');
    activePanels.forEach(function (panel) {
      panel.classList.remove('is-active');
    });

    const expandedTriggers = drawer.querySelectorAll('.c-mobile-menu_level2-trigger[aria-expanded="true"]');
    expandedTriggers.forEach(function (trigger) {
      trigger.setAttribute('aria-expanded', 'false');
    });
  }

  function openLevel3(drawer, trigger) {
    const panels = getPanels(drawer);
    if (!drawer || !panels || !trigger) return;

    const targetId = trigger.getAttribute('aria-controls');
    if (!targetId) return;

    const safeId = (window.CSS && typeof CSS.escape === 'function') ? CSS.escape(targetId) : targetId;
    const targetPanel = panels.querySelector('#' + safeId);
    if (!targetPanel) return;

    // パネル切替
    closeAllLevel3(drawer);
    drawer.classList.add('is-level3-open');
    panels.setAttribute('aria-hidden', 'false');

    targetPanel.classList.add('is-active');
    trigger.setAttribute('aria-expanded', 'true');

    // 戻る時のためにトリガーを保持
    if (lastTriggerByPanels) {
      lastTriggerByPanels.set(panels, trigger);
    } else {
      panels.__lastTrigger = trigger; // fallback
    }

    // フォーカス: 戻るボタンへ
    const backBtn = targetPanel.querySelector('[data-action="mobile-menu-back"]');
    if (backBtn && typeof backBtn.focus === 'function') {
      try {
        backBtn.focus({ preventScroll: true });
      } catch (e) {
        backBtn.focus();
      }
    }
  }

  function handleBack(drawer) {
    const panels = getPanels(drawer);
    if (!drawer || !panels) return;

    let lastTrigger = null;
    if (lastTriggerByPanels) {
      lastTrigger = lastTriggerByPanels.get(panels);
    } else if (panels.__lastTrigger) {
      lastTrigger = panels.__lastTrigger;
    }

    closeAllLevel3(drawer);

    if (lastTrigger && document.contains(lastTrigger) && typeof lastTrigger.focus === 'function') {
      try {
        lastTrigger.focus({ preventScroll: true });
      } catch (e) {
        lastTrigger.focus();
      }
    }
  }

  function init() {
    if (initialized) return;
    const drawer = getDrawer();
    const panels = getPanels(drawer);
    if (!drawer || !panels) return;

    initialized = true;

    // クリックはイベント委譲で処理
    drawer.addEventListener('click', function (event) {
      const target = event.target;
      if (!target) return;

      // 戻る
      const back = target.closest && target.closest('[data-action="mobile-menu-back"]');
      if (back) {
        event.preventDefault();
        handleBack(drawer);
        return;
      }

      // level2トリガー
      const trigger = target.closest && target.closest('.c-mobile-menu_level2-trigger');
      if (trigger) {
        event.preventDefault();
        openLevel3(drawer, trigger);
      }
    });

    // Escで戻る（パネル表示中のみ）
    drawer.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      if (!drawer.classList.contains('is-level3-open')) return;
      event.preventDefault();
      handleBack(drawer);
    });

    // ドロワー閉時: 即リセットすると「第2階層が見えてから閉じる」ため、閉じ切ってからリセット
    drawer.addEventListener('mobile-nav:close', function () {
      if (resetTimer) {
        clearTimeout(resetTimer);
        resetTimer = null;
      }

      // closeアニメーション終了後に初期化（見た目は第3階層のまま閉じる）
      resetTimer = setTimeout(function () {
        closeAllLevel3(drawer);
        resetTimer = null;
      }, 450);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // append-bodyなどで遅延しても確実に初期化
  document.addEventListener('mobile-nav:open', function () {
    init();
    if (resetTimer) {
      clearTimeout(resetTimer);
      resetTimer = null;
    }
    // 開くたびに初期状態へ（前回のパネル残りを防止）
    const drawer = getDrawer();
    if (drawer) closeAllLevel3(drawer);
  });
})();

/* メガメニュー: ヘッダーにカーソル移動しても閉じない */
(function () {
  function patchDesktopNavigation() {
    const DesktopNav = customElements.get("desktop-navigation");
    if (!DesktopNav || DesktopNav._megaMenuHeaderPatched) return;
    DesktopNav._megaMenuHeaderPatched = true;

    const originalOpen = DesktopNav.prototype.openDropdown;
    if (!originalOpen) return;

    DesktopNav.prototype.openDropdown = function (parentElement) {
      const menuItem = parentElement.querySelector("[aria-controls]");
      const dropdown = menuItem
        ? parentElement.querySelector("#" + menuItem.getAttribute("aria-controls"))
        : null;
      const isMegaMenu = dropdown && dropdown.classList.contains("mega-menu");

      if (!isMegaMenu) {
        return originalOpen.call(this, parentElement);
      }

      const self = this;
      self.openingTimeout = setTimeout(function () {
        if (menuItem.getAttribute("aria-expanded") === "true") return;

        self.currentMegaMenu = dropdown;
        menuItem.setAttribute("aria-expanded", "true");
        dropdown.removeAttribute("hidden");

        const leaveListener = function (e) {
          if (e.relatedTarget !== null) {
            const header = document.querySelector(".header");
            if (header && header.contains(e.relatedTarget)) return;
          }
          self.closeDropdown(parentElement);
          parentElement.removeEventListener("mouseleave", leaveListener);
        };
        const leaveDocumentListener = function () {
          self.closeDropdown(parentElement);
          document.documentElement.removeEventListener("mouseleave", leaveDocumentListener);
        };
        parentElement.addEventListener("mouseleave", leaveListener);
        document.documentElement.addEventListener("mouseleave", leaveDocumentListener);

        self.openingTimeout = null;
        self.dispatchEvent(new CustomEvent("desktop-nav:dropdown:open", { bubbles: true }));
      }, 100);

      parentElement.addEventListener(
        "mouseleave",
        function () {
          if (self.openingTimeout) clearTimeout(self.openingTimeout);
        },
        { once: true }
      );
    };
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", patchDesktopNavigation);
  } else {
    patchDesktopNavigation();
  }
})();

/* Custom Mega Menu（メニューハンドル「category」利用、画像なし）
   タブ切替・高さ計算・タブ内リンク無効化を一元管理
   対応: custom-mega-menu.liquid, custom-mega-menu-tabs.liquid, custom-mega-menu-content.liquid
*/
document.addEventListener("DOMContentLoaded", () => {
  /* 1. タブ切り替え（MegaMenuCategory__TabItem → Item__Wrap） */
  const activateTab = (element) => {
    const parentMenu = element.getAttribute("data-parent-menu");
    if (!parentMenu) return;

    document
      .querySelectorAll(`.MegaMenuCategory__TabItem[data-parent-menu="${parentMenu}"]`)
      .forEach((tab) => tab.classList.remove("is-active"));
    element.classList.add("is-active");

    document
      .querySelectorAll(`.Item__Wrap[data-parent-menu="${parentMenu}"]`)
      .forEach((item) => item.classList.remove("active"));

    const tabIndex = element.getAttribute("data-tab-item");
    const target = document.getElementById(`category-tab-${parentMenu}-${tabIndex}`);
    if (target) target.classList.add("active");
  };

  /* hover=背景+アイコン表示のみ、clickでactive＋タブ切替 */
  document.querySelectorAll(".MegaMenuCategory__TabItem").forEach((el) => {
    el.addEventListener("click", (e) => {
      e.preventDefault();
      activateTab(el);
    });
  });

  /* 2. 高さ自動計算（MegaMenuCategory__Tab / MegaMenuCategory__Content） */
  const setMegaMenuHeight = () => {
    requestAnimationFrame(() => {
      try {
        const header = document.querySelector(".header");
        const announcementBar = document.querySelector(".announcement-bar");
        const tabs = document.querySelectorAll(".MegaMenuCategory__Tab");
        const contents = document.querySelectorAll(".MegaMenuCategory__Content");

        if (!header || (!tabs.length && !contents.length)) return;

        const scrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
        const headerHeight = header.offsetHeight || 0;
        const announcementHeight = announcementBar ? announcementBar.offsetHeight || 0 : 0;
        const calculatedHeight =
          scrollTop <= 0 ? window.innerHeight - headerHeight - announcementHeight : window.innerHeight - headerHeight;
        const finalHeight = Math.min(Math.max(calculatedHeight, 0), 600);

        tabs.forEach((t) => { t.style.height = `${finalHeight}px`; });
        contents.forEach((c) => { c.style.height = `${finalHeight}px`; });
      } catch (err) {
        console.warn("Mega Menu height error:", err);
      }
    });
  };

  setMegaMenuHeight();
  const onResizeOrScroll = () => requestAnimationFrame(setMegaMenuHeight);
  window.addEventListener("scroll", onResizeOrScroll);
  window.addEventListener("resize", onResizeOrScroll);

  /* 3. タブ内リンク無効化（1番目のタブはaタグだが、タブ切替専用のため遷移させない） */
  const processedTabLinks = new WeakSet();
  const disableTabLinks = () => {
    document.querySelectorAll("a.MegaMenuCategory__TabLink").forEach((link) => {
      if (processedTabLinks.has(link)) return;

      link.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }, { once: false });
      link.style.cursor = "default";
      link.style.pointerEvents = "none";
      processedTabLinks.add(link);
    });
  };
  disableTabLinks();
  const tabLinkObserver = new MutationObserver(disableTabLinks);
  tabLinkObserver.observe(document.body, { childList: true, subtree: true });

  /* 4. 閉じるボタンクリックでメガメニューを閉じる */
  document.addEventListener("click", (e) => {
    const btn = e.target.closest("[data-action='mega-menu-close']");
    if (!btn) return;

    const megaMenu = btn.closest(".mega-menu");
    const parentLi = megaMenu ? megaMenu.closest(".header__linklist-item") : null;
    const desktopNav = btn.closest("desktop-navigation");

    if (megaMenu && parentLi && desktopNav && typeof desktopNav.closeDropdown === "function") {
      desktopNav.closeDropdown(parentLi);
    }
  });
});

/* 検索ドロワー: ヘッダー直下に正しく表示するため top を DOM 計測で設定 */
/* 検索ドロワー: 入力ありで content 高さを表示、未入力で高さ 0 */
(function () {
  let searchDrawerListenerAttached = false;

  function syncHasQuery(drawer) {
    const input = drawer && drawer.querySelector('[name="q"]');
    if (!input) return;
    if (input.value.trim().length > 0) {
      drawer.classList.add("c-header_search-drawer--has-query");
    } else {
      drawer.classList.remove("c-header_search-drawer--has-query");
    }
  }

  function attachSearchDrawerListeners(drawer) {
    if (searchDrawerListenerAttached) return;
    const input = drawer.querySelector('[name="q"]');
    if (!input) return;
    input.addEventListener("input", function () {
      syncHasQuery(drawer);
    });
    searchDrawerListenerAttached = true;
  }

  document.addEventListener("openable-element:open", function (e) {
    const drawer = e.target;
    if (drawer.id !== "search-drawer" || !drawer.classList.contains("c-header_search-drawer")) return;
    /* top 設定 */
    function setTop() {
      const headerSection = document.querySelector(".shopify-section--header");
      const ref = headerSection || document.querySelector("store-header");
      if (ref) {
        const rect = ref.getBoundingClientRect();
        drawer.style.setProperty("top", rect.bottom + "px");
      }
    }
    setTop();
    requestAnimationFrame(setTop);
    /* has-query 同期・リスナー */
    syncHasQuery(drawer);
    attachSearchDrawerListeners(drawer);
  });

  document.addEventListener("DOMContentLoaded", function () {
    const drawer = document.getElementById("search-drawer");
    if (drawer && drawer.classList.contains("c-header_search-drawer")) {
      syncHasQuery(drawer);
      attachSearchDrawerListeners(drawer);
    }
  });
})();

/* HeaderメニューでルートURL（/）のリンクを無効化 */
document.addEventListener("DOMContentLoaded", () => {
  const processedLinks = new WeakSet();

  const disableRootLinks = () => {
    const headerLinks = document.querySelectorAll(".header__linklist a, .header__linklist-link");

    headerLinks.forEach((link) => {
      if (processedLinks.has(link)) return;

      const href = link.getAttribute("href");
      if (href === "/" || href === window.location.origin + "/" || href === window.location.origin) {
        link.addEventListener("click", (e) => {
          e.preventDefault();
          e.stopPropagation();
          return false;
        }, { once: false });
        link.style.cursor = "default";
        link.style.pointerEvents = "none";
        processedLinks.add(link);
      }
    });
  };

  disableRootLinks();
  const observer = new MutationObserver(disableRootLinks);
  observer.observe(document.body, { childList: true, subtree: true });
});

/**
 * ワインカードのタグリスト: 同一行内で最大高さに揃え、タグを下揃え
 * - 2行のタグがあるカードがある行: 他カードも2行分の高さにして下揃え
 * - 1行のみの行: 自然な高さのまま（揃えない）
 */
(function () {
  const ROW_TOLERANCE = 3;

  function alignWineCardTagHeights() {
    document.querySelectorAll(".product-list__inner").forEach(function (inner) {
      const cards = inner.querySelectorAll(":scope > .c-product-card-wine");
      if (cards.length === 0) return;

      const tagLists = inner.querySelectorAll(".c-product-card-wine__tag-list");
      tagLists.forEach(function (el) {
        el.style.height = "";
        el.style.alignContent = "";
      });
      void inner.offsetHeight; /* reflow で自然な高さを確定 */

      const rows = [];
      let currentRow = [];
      let lastTop = null;

      cards.forEach(function (card) {
        const tagList = card.querySelector(".c-product-card-wine__tag-list");
        const rect = card.getBoundingClientRect();

        if (lastTop !== null && Math.abs(rect.top - lastTop) > ROW_TOLERANCE) {
          if (currentRow.length) rows.push(currentRow);
          currentRow = [];
        }
        if (tagList) currentRow.push(tagList);
        lastTop = rect.top;
      });
      if (currentRow.length) rows.push(currentRow);

      rows.forEach(function (rowTagLists) {
        const maxHeight = Math.max.apply(null, rowTagLists.map(function (el) { return el.offsetHeight; }));
        rowTagLists.forEach(function (el) {
          el.style.height = maxHeight + "px";
          el.style.alignContent = "flex-end";
        });
      });
    });
  }

  function debouncedAlign() {
    clearTimeout(alignWineCardTagHeights._tid);
    alignWineCardTagHeights._tid = setTimeout(alignWineCardTagHeights, 100);
  }

  function runAlign() {
    alignWineCardTagHeights();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      runAlign();
      setTimeout(runAlign, 600); /* reveal アニメーション後に対応 */
    });
  } else {
    runAlign();
    setTimeout(runAlign, 600);
  }
  window.addEventListener("resize", debouncedAlign);
  document.addEventListener("shopify:section:load", runAlign);
})();

/**
 * featured-collections セクションの横スクロールボタン: 1枚（1商品）ずつスライド
 * - デフォルトの ProductList は画面幅分スクロールするため、イベントをキャプチャして上書き
 * - 左余白は inner の padding-inline-start で表現。scrollLeft=0 で左端カードが余白の直後から開始
 */
(function () {
  function setInitialScroll(inner) {
    inner.scrollLeft = 0;
  }

  function updatePrevNextButtons(inner, prevNextButtons) {
    const prevBtn = prevNextButtons?.querySelector(".prev-next-button--prev");
    const nextBtn = prevNextButtons?.querySelector(".prev-next-button--next");
    if (!prevBtn || !nextBtn) return;

    const productList = prevNextButtons.closest("product-list");
    const directionFlip = (window.themeVariables?.settings?.direction === "rtl") ? -1 : 1;
    const scrollLeft = inner.scrollLeft * directionFlip;
    const maxScroll = inner.scrollWidth - inner.clientWidth;

    prevBtn.disabled = scrollLeft <= 1;
    nextBtn.disabled = scrollLeft >= maxScroll - 1;
  }

  function handlePrevNext(event) {
    const prevNextButtons = event.target.closest("prev-next-buttons");
    if (!prevNextButtons) return;

    const productList = prevNextButtons.closest("product-list");
    if (!productList || !productList.closest(".shopify-section--featured-collections")) return;

    event.stopPropagation();

    const inner = productList.querySelector(".product-list__inner");
    if (!inner) return;

    const firstItem = inner.querySelector("product-item");
    if (!firstItem) return;

    const directionFlip = (window.themeVariables?.settings?.direction === "rtl") ? -1 : 1;
    const columnGap = parseInt(getComputedStyle(productList).getPropertyValue("--product-list-column-gap") || "24", 10);
    const scrollAmount = firstItem.offsetWidth + columnGap;

    const isPrev = event.type === "prev-next:prev";
    const delta = (isPrev ? -1 : 1) * scrollAmount * directionFlip;

    inner.scrollBy({ left: delta, behavior: "smooth" });
  }

  function setupScrollListeners() {
    document.querySelectorAll(".shopify-section--featured-collections product-list").forEach(function (productList) {
      const inner = productList.querySelector(".product-list__inner");
      const prevNextButtons = productList.querySelector("prev-next-buttons.product-list__prev-next");
      if (!inner || !prevNextButtons) return;

      if (inner.dataset.fcScrollListener === "1") return;
      inner.dataset.fcScrollListener = "1";

      inner.addEventListener("scroll", function () {
        updatePrevNextButtons(inner, prevNextButtons);
      }, { passive: true });

      /* 初期位置・タブ切替時: padding-inline-start 分を scrollLeft に設定 */
      if (!productList.hidden) {
        requestAnimationFrame(function () {
          setInitialScroll(inner);
          updatePrevNextButtons(inner, prevNextButtons);
        });
      }

      /* タブ切替で表示になったときに scrollLeft を初期値に */
      const obs = new MutationObserver(function () {
        if (!productList.hidden) {
          requestAnimationFrame(function () {
            setInitialScroll(inner);
            updatePrevNextButtons(inner, prevNextButtons);
          });
        }
      });
      obs.observe(productList, { attributes: true, attributeFilter: ["hidden"] });
    });
  }

  document.addEventListener("prev-next:prev", handlePrevNext, true);
  document.addEventListener("prev-next:next", handlePrevNext, true);

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", setupScrollListeners);
  } else {
    setupScrollListeners();
  }
  document.addEventListener("shopify:section:load", setupScrollListeners);
})();

/**
 * コレクション絞り込みサイドバー: 該当件数を動的に同期
 * product-facet の facet-main 更新時に、meta-bar の件数を c-product-facet__count へ反映
 */
(function () {
  function syncFacetCountToHeader(productFacet) {
    const facetMain = productFacet.querySelector("#facet-main");
    let countTarget = productFacet.querySelector(".c-product-facet__count");
    if (!facetMain) return;

    const metaBarCount = facetMain.querySelector(".product-facet__meta-bar-item--count");
    const header = productFacet.querySelector(".c-product-facet__filters-header");
    const filtersTitle = header ? header.querySelector(".c-product-facet__filters-title") : null;

    if (metaBarCount && metaBarCount.textContent.trim()) {
      const num = parseInt(metaBarCount.textContent.trim(), 10);
      if (!isNaN(num) && num > 0) {
        if (!countTarget && filtersTitle) {
          countTarget = document.createElement("span");
          countTarget.className = "c-product-facet__count";
          countTarget.setAttribute("role", "status");
          filtersTitle.appendChild(document.createTextNode(" "));
          filtersTitle.appendChild(countTarget);
        }
        /* モバイルバー内の c-product-facet__count も更新（複数ある場合はすべて） */
        const allCountTargets = productFacet.querySelectorAll(".c-product-facet__count");
        allCountTargets.forEach(function (el) {
          el.textContent = num;
          el.hidden = false;
        });
      } else {
        const allCountTargets = productFacet.querySelectorAll(".c-product-facet__count");
        allCountTargets.forEach(function (el) {
          el.hidden = true;
          el.textContent = "";
        });
      }
    } else {
      const allCountTargets = productFacet.querySelectorAll(".c-product-facet__count");
      allCountTargets.forEach(function (el) {
        el.hidden = true;
        el.textContent = "";
      });
    }
  }

  function setupFacetCountObserver(productFacet) {
    const facetMain = productFacet.querySelector("#facet-main");
    const hasCountTarget =
      productFacet.querySelector(".c-product-facet__filters-header") ||
      productFacet.querySelector(".c-product-facet__mobile-bar_filter");
    if (!facetMain || !hasCountTarget) return;

    const observer = new MutationObserver(function () {
      /* 更新時に textContent 変更で observer が再発火して無限ループするため、先に disconnect */
      observer.disconnect();
      syncFacetCountToHeader(productFacet);
      observer.observe(facetMain, { childList: true, subtree: true });
    });
    observer.observe(facetMain, { childList: true, subtree: true });
  }

  function initFacetCountSync() {
    document.querySelectorAll("product-facet .c-product-facet__filters-header, product-facet .c-product-facet__mobile-bar_filter").forEach(function (el) {
      const productFacet = el.closest("product-facet");
      if (!productFacet || productFacet.dataset.facetCountObserved) return;
      productFacet.dataset.facetCountObserved = "1";
      setupFacetCountObserver(productFacet);
      syncFacetCountToHeader(productFacet);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initFacetCountSync);
  } else {
    initFacetCountSync();
  }
  document.addEventListener("shopify:section:load", initFacetCountSync);
})();

/**
 * コレクション絞り込み: 価格フィルターの値をShopify形式（最小単位）に変換
 * 表示は円単位（÷100）だが、送信時は×100する必要がある
 */
(function () {
  const PRICE_DIVISOR = 100;
  const PRICE_PARAM_GTE = "filter.v.price.gte";
  const PRICE_PARAM_LTE = "filter.v.price.lte";

  document.addEventListener("facet:criteria-changed", function (event) {
    if (!event.detail || !event.detail.url) return;
    try {
      const url = new URL(event.detail.url);
      let modified = false;
      [PRICE_PARAM_GTE, PRICE_PARAM_LTE].forEach(function (param) {
        const val = url.searchParams.get(param);
        if (val !== null) {
          const num = parseInt(val, 10);
          if (!isNaN(num)) {
            url.searchParams.set(param, String(num * PRICE_DIVISOR));
            modified = true;
          }
        }
      });
      if (modified) {
        event.detail.url = url.toString();
      }
    } catch (e) {
      /* URL パース失敗時は無視 */
    }
  }, true);
})();

/**
 * 商品詳細タブ切り替え（商品情報 / 生産者の詳細 / 生産地の詳細）
 * - クリックでタブ切替、aria-selected / hidden でアクセシビリティ対応
 * - キーボード: 左右矢印でタブ間移動、Enter/Spaceで選択
 */
(function () {
  function initProductInfoTabs() {
    document.querySelectorAll(".c-product-info__tabs").forEach(function (tabsEl) {
      if (tabsEl.dataset.tabsInitialized) return;
      tabsEl.dataset.tabsInitialized = "1";

      const triggers = tabsEl.querySelectorAll(".c-product-info__tab-trigger");
      const panels = tabsEl.querySelectorAll(".c-product-info__tab-panel");

      function switchTab(targetId) {
        const target = targetId ? tabsEl.querySelector('[data-tab-target="' + targetId + '"]') : null;
        if (!target) return;

        triggers.forEach(function (btn) {
          const isActive = btn === target;
          btn.classList.toggle("is-active", isActive);
          btn.setAttribute("aria-selected", String(isActive));
          const panelId = btn.getAttribute("aria-controls");
          const panel = panelId ? document.getElementById(panelId) : null;
          if (panel) {
            panel.classList.toggle("is-active", isActive);
            panel.hidden = !isActive;
          }
        });
      }

      triggers.forEach(function (btn) {
        btn.addEventListener("click", function () {
          switchTab(btn.getAttribute("data-tab-target"));
        });

        /* キーボード: 左右矢印でタブ移動 */
        btn.addEventListener("keydown", function (e) {
          let next = null;
          if (e.key === "ArrowLeft" || e.key === "Home") {
            e.preventDefault();
            next = e.key === "Home" ? triggers[0] : btn.previousElementSibling || triggers[triggers.length - 1];
          } else if (e.key === "ArrowRight" || e.key === "End") {
            e.preventDefault();
            next = e.key === "End" ? triggers[triggers.length - 1] : btn.nextElementSibling || triggers[0];
          }
          if (next && next.classList.contains("c-product-info__tab-trigger")) {
            next.focus();
            switchTab(next.getAttribute("data-tab-target"));
          }
        });
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initProductInfoTabs);
  } else {
    initProductInfoTabs();
  }
  document.addEventListener("shopify:section:load", initProductInfoTabs);
})();

/**
 * スタッフレビュー「レビュー全文を読む」ボタン：クリックで全文表示＋ボタン削除
 */
(function () {
  function initStaffReviewToggle() {
    document.querySelectorAll("[data-staff-review-toggle]").forEach(function (btn) {
      if (btn.dataset.staffReviewInitialized) return;
      btn.dataset.staffReviewInitialized = "1";

      btn.addEventListener("click", function () {
        // 同一スタッフレビューブロック内の body を取得（ID は product-rerender 等で不整合になる場合があるため相対参照を優先）
        const staffReview = btn.closest(".c-product-info__staff-review");
        const body =
          (staffReview && staffReview.querySelector(".c-product-info__staff-review-body")) ||
          (btn.getAttribute("aria-controls") && document.getElementById(btn.getAttribute("aria-controls"))) ||
          btn.parentElement?.previousElementSibling;
        if (body && body.classList.contains("c-product-info__staff-review-body")) {
          body.classList.add("is-expanded");
          btn.setAttribute("aria-expanded", "true");
          // WebKit の -webkit-line-clamp 不具合対策：display の再計算を強制
          const text = body.querySelector(".c-product-info__staff-review-text");
          if (text) {
            text.style.display = "none";
            void text.offsetHeight;
            text.style.display = "";
          }
          btn.remove();
        }
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initStaffReviewToggle);
  } else {
    initStaffReviewToggle();
  }
  document.addEventListener("shopify:section:load", initStaffReviewToggle);
})();
